import * as React from 'react';

type MenuItemSelect = { markItemSelected: () => void; isItemSelected: () => boolean };

export const MenuItemSelectContext = React.createContext<MenuItemSelect>({
  markItemSelected: () => {},
  isItemSelected: () => false,
});
